module.exports = __webpack_public_path__ + "files/SPIADI2026 - SPY4 - Fiche (Version 1).03e8a68019329071e5b710f3a15cf1d7.pdf";